import {
  SUMMARY_ADD_UNAVAILABLE_PRODUCTS_TO_LIST,
  SUMMARY_SET_MODAL_TYPE,
  SUMMARY_SET_CURRENT_CONFIGURATION,
  SUMMARY_SET_CONFIRMATION_CARD_TYPE,
  SUMMARY_SET_MODAL_STATE,
  SUMMARY_SET_SHOPPING_ITEMS,
  SUMMARY_SET_STATE,
  SUMMARY_SET_STORE_AVAILABILITIES,
  SUMMARY_SET_STORE_ID,
  SUMMARY_SET_VPC_CODE,
  SUMMARY_SET_DESIGN_LINK,
  SUMMARY_CLEAR_BUTTON,
  SUMMARY_SET_COPY_DESIGN_CODE_STATE,
  SUMMARY_SET_COPY_DESIGN_LINK_STATE,
  SUMMARY_SET_FAILED_SHOPPING_ITEMS,
  SUMMARY_SET_SHARE_DESIGN_CARD,
  SUMMARY_SET_HOME_DELIVERY,
  SUMMARY_SET_SCENE_IMAGE,
  SUMMARY_SET_FINANCING_OPTIONS,
} from '../actionConstants';
import { AddToBagStateEnum } from '@inter-ikea-kompis/component-add-to-bag';
import { SummaryPageConfirmationCardTypeEnum } from '@inter-ikea-kompis/component-summary-page';
import { ConfirmationSummaryShareDesignStateEnum } from '@inter-ikea-kompis/component-configuration-summary';
import { SendByEmailStateEnum } from '@inter-ikea-kompis/component-send-by-email';
import { IFinancingOption, IZipAvailability } from '@inter-ikea-kompis/types';

export const ADD_TO_LIST = 'addToList';
export const ADD_TO_CART = 'addToCart';
export const SEND_BY_EMAIL = 'sendByEmailState';
export const SEND_BY_EMAIL_VALUE = 'sendByEmailValue';
export const SEND_BY_EMAIL_INVALID_INPUT = 'sendByEmailInvalidInput';
export const SET_SHARE_DESIGN_CARD_STATE = 'state';
export const SET_HOME_DELIVERY_STATE = 'state';
export const SET_HOME_DELIVERY_ZIP_CODE = 'zipCode';
export const SET_HOME_DELIVERY_INPUT_VALUE = 'inputValue';
export const SET_HOME_DELIVERY_ZIP_AVAILABILITIES = 'zipAvailabilities';

export const SAVE_VPC = 'saveVpc';

export const actionSetStoreId = (storeId: string) => ({
  type: SUMMARY_SET_STORE_ID,
  payload: { storeId },
});

export const actionSetStoreAvailabilities = (
  specificStoreAvailabilities: any
) => ({
  type: SUMMARY_SET_STORE_AVAILABILITIES,
  payload: {
    specificStoreAvailabilities,
  },
});

export const actionSetShoppingItems = (shoppingItems: any) => ({
  type: SUMMARY_SET_SHOPPING_ITEMS,
  payload: { shoppingItems },
});

export const actionSetVpcCode = (vpcCode: string) => ({
  type: SUMMARY_SET_VPC_CODE,
  payload: { vpcCode },
});

export const actionSetDesignLink = (designLink: string) => ({
  type: SUMMARY_SET_DESIGN_LINK,
  payload: { designLink },
});

export const actionSetSceneImage = (sceneImage: string) => ({
  type: SUMMARY_SET_SCENE_IMAGE,
  payload: { sceneImage },
});

const actionSetSummaryPageState =
  (target: string) =>
  (state: AddToBagStateEnum | ConfirmationSummaryShareDesignStateEnum) => ({
    type: SUMMARY_SET_STATE,
    payload: { target, state },
  });

export const actionSetAddToListState = actionSetSummaryPageState(ADD_TO_LIST);
export const actionSetAddToCartState = actionSetSummaryPageState(ADD_TO_CART);

const actionSetShareDesignCard =
  (target: string) => (state: SendByEmailStateEnum | boolean | string) => ({
    type: SUMMARY_SET_SHARE_DESIGN_CARD,
    payload: { target, state },
  });

export const actionSetSendByEmailState =
  actionSetShareDesignCard(SEND_BY_EMAIL);

export const actionSetShareDesignCardState = actionSetShareDesignCard(
  SET_SHARE_DESIGN_CARD_STATE
);

const actionSetHomeDelivery =
  (target: string) => (state: IZipAvailability[] | string | undefined) => ({
    type: SUMMARY_SET_HOME_DELIVERY,
    payload: { target, state },
  });

export const actionSetHomeDeliveryState = actionSetHomeDelivery(
  SET_HOME_DELIVERY_STATE
);
export const actionSetHomeDeliveryZipCode = actionSetHomeDelivery(
  SET_HOME_DELIVERY_ZIP_CODE
);
export const actionSetHomeDeliveryInputValue = actionSetHomeDelivery(
  SET_HOME_DELIVERY_INPUT_VALUE
);
export const actionSetHomeDeliveryZipAvailabilities = actionSetHomeDelivery(
  SET_HOME_DELIVERY_ZIP_AVAILABILITIES
);

export const actionSetConfirmationCardType = (
  confirmationCardType: SummaryPageConfirmationCardTypeEnum
) => ({
  type: SUMMARY_SET_CONFIRMATION_CARD_TYPE,
  payload: { confirmationCardType },
});

export const actionSetShowModal = () => ({
  type: SUMMARY_SET_MODAL_STATE,
  payload: { modalState: true },
});

export const actionSetHideModal = () => ({
  type: SUMMARY_SET_MODAL_STATE,
  payload: { modalState: false },
});

export const actionClearButtons = () => ({
  type: SUMMARY_CLEAR_BUTTON,
});

export const actionSetModalType = (modalType: any) => ({
  type: SUMMARY_SET_MODAL_TYPE,
  payload: { modalType },
});

export const actionSetAddUnavailableProductsToList = (
  addUnavailableProductsToList: boolean
) => ({
  type: SUMMARY_ADD_UNAVAILABLE_PRODUCTS_TO_LIST,
  payload: { addUnavailableProductsToList },
});

export const actionSetCurrentConfiguration = (currentConfiguration: any) => ({
  type: SUMMARY_SET_CURRENT_CONFIGURATION,
  payload: { currentConfiguration },
});

export const actionSetCopyDesignCodeState = (
  shareDesignCardCopyState: any
) => ({
  type: SUMMARY_SET_COPY_DESIGN_CODE_STATE,
  payload: { shareDesignCardCopyState },
});

export const actionSetCopyDesignLinkState = (
  shareDesignCardLinkState: any
) => ({
  type: SUMMARY_SET_COPY_DESIGN_LINK_STATE,
  payload: { shareDesignCardLinkState },
});

export const actionSetFailedShoppingItems = (failedShoppingItems: any) => ({
  type: SUMMARY_SET_FAILED_SHOPPING_ITEMS,
  payload: { failedShoppingItems },
});

export const actionSetFinancingOptions = (
  financingOptions: IFinancingOption | undefined
) => ({
  type: SUMMARY_SET_FINANCING_OPTIONS,
  payload: { financingOptions },
});
